import { Component, OnInit, ViewChild, TemplateRef, HostListener, OnDestroy } from '@angular/core';
// import { UsersService } from '@app/users/users.service';
import { StateService, WsService, Client } from '@app/shared';
import { Subject } from 'rxjs/Subject';
import { User } from '@app/users/user.interface';
import { MatDialog } from '@angular/material';
import { UserFormComponent } from '@app/users/user-form/user-form.component';
import { DeleteUserComponent } from '@app/users/delete-user/delete-user.component';
import { UsersDataService } from '../users-data.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {
  @ViewChild('controlMenu') controlMenu: TemplateRef<any>;
  @ViewChild('titlePage') titlePage: TemplateRef<any>;
  title = 'USERS-PAGE-TITLE';
  private componentDestroyed = new Subject();
  currentUser: User = null;
  constructor(
    // private users: UsersService,
    private state: StateService,
    public dialog: MatDialog,
    private ws: WsService,
    private client: Client,
    private dataService: UsersDataService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.componentDestroyed.next(true);
    this.componentDestroyed.unsubscribe();
  }

  // Editing to doubleclick on user
  onDbClick(user) {
    if (user.id) {
      let dialogRef = this.dialog.open(UserFormComponent, {
        data: user,
        height: '420px',
        width: '500px',
        disableClose: true
      });
    }
  }

  create(user?: User) {
    let dialogRef = this.dialog.open(UserFormComponent, {
      height: '420px',
      width: '500px',
      disableClose: true
    });
  }

  edit() {
    let dialogRef = this.dialog.open(UserFormComponent, {
      data: this.currentUser,
      height: '420px',
      width: '500px',
      disableClose: true
    });
  }

  delete() {
    let dialogRef = this.dialog.open(DeleteUserComponent, {
      data: this.currentUser
    });
  }
  setCurrentUser(user: User) {
    this.currentUser = user;
  }

  @HostListener('window:keydown', ['$event'])
  onkeyup($event) {
    if ($event.keyCode === 45 && this.dialog.openDialogs.length == 0) {
      $event.preventDefault();
      this.dialog.open(UserFormComponent, {
        height: '420px',
        width: '500px',
        disableClose: true
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/users/users/users.component.ts